import { path } from 'ramda';

const domain = path(['etp', 'config', 'domain'], window);
const projectName = path(['etp', 'config', 'projectName'], window);
const availableRoutes = path(['etp', 'config', 'availableRoutes'], window);
const featureCookieName = path(
  ['etp', 'config', 'feature_cookie_name'],
  window,
);

export { domain, availableRoutes, projectName, featureCookieName };
